import { cn } from "@/lib/utils";
import { Button, buttonVariants } from "../ui/button";
import { ComponentProps } from "react";
import { Show } from "./show";
import { VariantProps } from "class-variance-authority";

interface ExtendedButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  loading?: boolean;
  iconProps?: ComponentProps<"span">;
}

export const ActionButton = ({
  children,
  loading = false,
  className,
  iconProps,
  ...props
}: ExtendedButtonProps) => {
  return (
    <Button
      disabled={loading || props.disabled}
      {...props}
      className={cn(
        "testify-flex testify-items-center testify-gap-2",
        className,
      )}
    >
      {children}
      <Show when={loading}>
        <span {...iconProps} className="spinner"></span>
      </Show>
    </Button>
  );
};
